// Boots the mock backend. Enabled by default; set VITE_ENABLE_MOCKS=false to
// point the same OctoClient at a real focalboard server instead.

import {setupWorker} from 'msw/browser'
import {handlers} from './handlers'

let worker: ReturnType<typeof setupWorker> | undefined

export async function startMocks(): Promise<void> {
    if (worker) {
        return
    }
    worker = setupWorker(...handlers)
    await worker.start({
        onUnhandledRequest: 'warn',
        serviceWorker: {url: `${import.meta.env.BASE_URL}mockServiceWorker.js`},
    })
}

export const mocksEnabled = import.meta.env.VITE_ENABLE_MOCKS !== 'false'
